import { MenuItem } from "@mui/material";
import { themeColors } from "Global/JsxThemeColor/JsxThemeColor";
import React from "react";
import { ArabicToPersian } from "utils/ConvertToPersianTextFromArabic";

const MenuItemRenderer = ({ isSingle, UiValue, element }) => {
  return (
    <>
      {!isSingle ? (
        UiValue.includes(element?.ItemValue) ? (
          <>
            {ArabicToPersian(element?.ItemContent)}
              
            <div
              style={{
                width: ".6em",
                height: ".6em",
                backgroundColor: themeColors.ColorPrimary,
                borderRadius: "100%",
              }}
            ></div>
          </>
        ) : (
          ArabicToPersian(element?.ItemContent)
        )
      ) : UiValue === element?.ItemContent ? (
        <>
          {ArabicToPersian(element?.ItemContent)}
            
          <div
            style={{
              width: ".6em",
              height: ".6em",
              backgroundColor: "green",
              borderRadius: "100%",
            }}
          ></div>
        </>
      ) : (
        element?.ItemContent
      )}
    </>
  );
};

export default MenuItemRenderer;
